<!-- 
  COMPONENT ConditionsOfUse
-->


<!---------- SCRIPT ---------->

<script lang="ts" type="module">

	import { onMount } from "svelte";
	import { deglingos, minitel, english } from "../store/store";

	onMount(async () => {
		window.scrollTo(0, 0);
	})

</script>


<!---------- STYLE ---------->

<style lang="scss">

	.section {
		&__deglingos {
			border-radius: 2% 15% 2% 2%;
		}
	}

	.article {
		&__p {
			text-align: left;
		}
	}

	@include large {
		.section {
			padding: 0 16px 0 16px;
			align-items: flex-start;
			&__deglingos {
				margin: 0 32px 32px 32px;
			}
		}

		.article {
			width: 100%;
			&__deglingos {
				align-self: flex-end;
			}
		}
	}
	
</style>


<!---------- TEMPLATE ---------->

<div class="pageContent">
	{#if $english}
		<h1 class="article__h1" class:article__minitel__h1={$minitel}>TERMS OF SALES</h1>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
			class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>IT IMPLEMENTATIONS</h1>
				<p class="article__p">
					These are concluded between:
				</p>
				<p class="article__p">
					KÖRTEFA - Yvan Poirier - Freelance, electing domicile at
					3 Redier subdivision 50590 Montmartin sur mer, FRANCE,
					identified under the SIREN number 801 185 448,
					represented by Yvan Poirier. <br>
					Here in after referred to as the "service provider"
				</p>
				<p class="article__p">
					And any natural or legal person, individual or professional,
					private or public law wishing to engage in one or more
					services provided by the "service provider". <br>
					Here in after referred to as the "client"
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 1 - Scope</h1>
				<p>
					These general conditions of sale (here in after "GTC") apply to all services
					IT services concluded by the "service provider" with his "client", which
					whatever clauses may appear on the "client's" documents, in particular its conditions
					general purchasing.
				</p>
				<p>
					By signing a quotation from the "service provider", the "client" acknowledges having had a
					perfect knowledge of the GTC.
				</p>
				<p>
					Each of the clauses of the contract is sufficient in itself, the invalidation of one
					having no effect on others.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 2 - Obligations of the "service provider"</h1>
				<p>
					The "service provider" is responsible for the proper management of the entrusted files.
					The commitments of the "service provider" constitute an obligation of means, and
					no result, under the terms of which the services will be performed in
					strict compliance with the professional rules in use as well, where applicable,
					only in accordance with the terms of the contract.
				</p>
				<p>
					The "service provider" acknowledges being bound by an obligation to advise and
					warning, in particular of information and recommendation to the "client" limited
					within the scope of services. In this context, the "service provider" must provide
					to the "client" all advice, warnings and recommendations
					necessary, particularly in terms of quality of service and upgrading
					art. The "service provider" undertakes to advise the "client" in the event that
					the latter would issue additional or new requests, in progress
					execution hereof. The "service provider" also undertakes to inform
					the "client" as soon as the "service provider" has been made aware of any novelty
					technological or availability of any new products or services allowing
					to significantly improve the service, and which would occur during the execution hereof.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 3 - Obligations of the "client"</h1>
				<p>
					In order to facilitate the proper performance of the services, the "client" undertakes:
				</p>
				<ul>
					<li>
						to provide the "service provider" with complete information and documents,
						accurate and on time without having to check
						completeness or accuracy
					</li>
					<li>
						make timely decisions and obtain the necessary hierarchical approvals
					</li>
					<li>
						to designate a correspondent with decision-making power
					</li>
					<li>
						to ensure that the key contacts and the correspondent are available
						throughout the performance of the services
					</li>
					<li>
						to inform the "service provider" directly of any possible difficulty relating to
						to the performance of services
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 4 - Information and confidentiality</h1>
				<p>
					The "service provider" is subject to a legal obligation of professional secrecy.
				</p>
				<p>
					Each of the parties undertakes, on its own behalf and that of their staff, not to
					disclose confidential information received from the other party. Information
					confidential means information of any kind, visual or oral,
					on any medium whatsoever, relating to the structure, organization,
					business, various internal policies, projects and personnel
					of each of the parties. Subject to the exceptions set out below, this
					confidentiality obligation will take effect for a period of 1 year following
					the term of services. Also of a confidential nature, the content of
					services as well as reports, letters, information, notes, quotes,
					provided by the "service provider" during the performance of the services.
					These documents are communicated to the "client" for strictly internal use and
					on the condition of not disclosing them to third parties or attaching them to a document
					that he would have to produce. If the "client" wishes all or part of these
					documents are disclosed to / or used by a third party, he must request them
					prior written authorization to the "service provider". Applicable terms
					this disclosure will then be set.
				</p>
				<p>
					The obligations and restrictions set out above do not apply to confidential information:
				</p>
				<ul>
					<li>
						which are in the public domain, or have been
						freely acquired before the start of the service
					</li>
					<li>
						which are or become known other than as a result of a violation of this article
					</li>
					<li>
						which are or become known through other sources not bound by a disclosure restriction
					</li>
					<li>
						which must be communicated by virtue of a legal or professional obligation or to
						the request of any judicial or regulatory authority empowered to require the
						disclosure of confidential information
					</li>
				</ul>
				<p>
					Subject to its obligations in terms of confidentiality, the "service provider"
					reserves the right to perform services for companies competing with
					that of the “client”.
				</p>
				<p>
					The "client" recognizes and accepts:
				</p>
				<ul>
					<li>
						that the parties may, unless expressly requested otherwise by the other party, correspond or transfer
						documents by e-mail circulating on the internet
					</li>
					<li>
						that neither party has control over capacity, reliability,
						access or security of these emails
					</li>
					<li>
						that the "service provider" cannot be held responsible for any loss, damage,
						costs or damage caused by loss, delay, interception,
						the hijacking or alteration of any e-mail caused by any fact
					</li>
				</ul>
				<p>
					The "service provider" does not market or rent the information collected to third parties.
				</p>
				<p>
					In general, the parties undertake to comply with the regulations applicable to the
					protection of personal data and in particular the provisions of Law 78-17 of 6
					January 1978 relating to computers, files and freedoms. In application of
					article 27 of this law, the "client" has a right of access and rectification
					on the data concerning the "customer". To do this, simply send an e-mail
					to the "service provider" at contact@kortefa.net or write to the "service provider",
					3 Redier subdivision 50590 Montmartin sur mer.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 5 - Intellectual property</h1>
				<p>
					In the event that one of the recommendations of the "service provider" or the use of elements
					delivered following one of its recommendations would involve the use of goods
					subject to intellectual property rights belonging to third parties,
					the "service provider" will inform the "client" of the existence of these rights and of the
					consequences of their use. It will then belong to the "client" and under his
					sole responsibility to take any measure allowing the use of such rights,
					in particular by negotiating for its own account the rights of use in
					conditions such that the "service provider" is able to rely on them to
					benefit needs.
				</p>
				<p>
					The "service provider" remains the owner of all intellectual property rights
					and industrial on studies, drawings, models, prototypes, etc. carried out with a view to
					the provision of services by the "provider" to the "client". The customer "
					is therefore prohibited any reproduction or exploitation of said works without the authorization
					express, written and prior from the "service provider" who may condition it to a
					financial compensation.
				</p>
				<p>
					The "client" agrees to provide the "service provider" with photos for which he has the image rights.
				</p>
				<p>
					The "service provider" will in no way be responsible for the photos provided by the "client",
					nor of the texts written by him, as much on the websites as on any other
					communication medium produced by the "service provider" for his "client".
				</p>
				<p>
					However, the "service provider" reserves the right not to publish or not
					print photos or texts deemed questionable or unethical
					and ethics.
				</p>
				<p>
					The "service provider" is not responsible for drafting the "client" texts,
					nor spell or syntax correction, unless otherwise stated in the estimate.
				</p>
				<p>
					The "service provider" may use the logo of the "client" in order to insert it into
					its references on its various communication media. The "client" authorizes
					also the "service provider" to illustrate, describe the services provided and
					point a page of its website to the activated address of the domain name
					of the "customer", and this, as an example of realization.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 6 - Ownership of developments</h1>
				<p>
					By default, the programs and other developments (files, data, etc.) that
					the "service provider" will send it to the "client" for the validation of the contract,
					remain the exclusive property of the "client".
				</p>
				<p>
					This is valid for all developments carried out on a free basis (open source).
					The "client" will thus be able to involve service providers other than the "service provider".
					for the maintenance or development of other elements, subject to compliance by
					the latter of these license conditions.
				</p>
				<p>
					However, this provision cannot apply as long as the "client" is bound by a
					maintenance contract, accepted on quotation, as described in article 11
					"Annual maintenance". Indeed, the "service provider" cannot guarantee
					a quality of service on developments of which it is not aware.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 7 - Domain names and hosting</h1>
				<h2>With maintenance</h2>
				<p>
					The "service provider" advises the "client" in the choice of one or more names
					domain name and associated hosting, according to the needs expressed by
					the customer ". If the "client" already has such environments, he must
					provide the "service provider" with all the information necessary to administer them.
					The "service provider" does not own either the domain name (s) or the
					accommodation, the owner is the "client". The "client" authorizes
					the "service provider" to register as a technical contact in order to administer
					the technical environments at the host. The "customer" will be registered
					as administrative contact and billing contact. As such, charge to
					"Client" to renew his services and pay the bills to the host.
				</p>
				<p>
					The "service provider" will monitor the deadlines and warn the "client" of the actions to be carried out.
				</p>
				<p>
					The fact of not renewing the services with the host could not
					be an admissible reason for terminating this contract.
				</p>
				<p>
					In addition, the "service provider" could not be held liable in the event of
					unavailability of the hosting service or any other lack of quality
					of service attributable to the host and domain name provider. The customer "
					will refer to the general conditions of sale of the host, and more particularly to:
				</p>
				<ul>
					<li>
						special web hosting conditions
					</li>
					<li>
						special conditions domain names
					</li>
					<li>
						general terms of service
					</li>
					<li>
						...
					</li>
				</ul>
				<h2>Without maintenance</h2>
				<p>
					The "customer" will be responsible for any relationship with the host (management, cost, infrastructure). The "provider" will not intervene in this relationship.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 8 - Social networks and other web communication platforms on the internet</h1>
				<p>
					According to the needs expressed by the "customer" and validated during the order,
					the "service provider" can advise and set up a
					web communication system with major market players
					(Facebook, Google, Twitter,…). The "client" will then be in charge
					to administer these different accounts, pages, flows and contents. The customer "
					is the owner of these various accounts, pages, feeds and content and
					is solely responsible for the texts, images, videos,… disseminated as well as the comments made.
					The "service provider" could not be held liable in the event of
					breach of image rights, copyright, non-compliance with ethics
					and ethics, as well as in the event of unavailability of platforms or
					any other lack of quality of service attributable to these external suppliers.
				</p>
				<p>
					The "client" will refer to the various conditions of these suppliers,
					and more particularly to:
				</p>
				<ul>
					<li>
						conditions applicable to Facebook pages
					</li>
					<li>
						Facebook conditions and regulations (known as "policies")
					</li>
					<li>
						Google terms of service
					</li>
					<li>
						google privacy policy
					</li>
					<li>
						Twitter terms of service
					</li>
					<li>
						...
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 9 - Terms of provision of services</h1>
				<p>
					In accordance with the principles of contractual freedom, all the modalities of
					provision of the requested services are almost possible. Note
					that in the absence of a contractual deadline for the provision of services, the "service provider"
					must carry out these within a reasonable time and inform the "client" of
					any delay. A posting date for a website or delivery
					for any other communication medium, is set at the latest in phase
					development as described in article 10 "Conditions of execution".
					The "service provider" undertakes to respect this deadline, if, and only if, all
					the elements to be provided by the "customer" (digitized texts, images,
					validation of the graphic charter, information and any element emanating from
					of the "client") are provided within the times and under the conditions defined by
					the provider ". This deadline does not constitute a strict deadline and the
					"Service provider" cannot be held liable for the "client"
					in the event of delay by service providers. The responsibility of the "service provider"
					can in no case be engaged in the event of delay or suspension of the
					provision of the service attributable to the "client", or in the event of force majeure.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 10 - Conditions of execution</h1>
				<p>
					The commercial proposal includes all the points on which the "service provider"
					will intervene. Once signed by the "client", the "service provider" will launch
					the service with the "client", the progress of which is generally organized in 4 phases:
				</p>
				<ul>
					<li>
						<i> Pre-project </i>: analysis of the existing situation, listening, advice, awareness, validation
						objectives and scope, detailed specifications and details of the notebook
						loads, graphic orientations, definition of content types and
						functionalities, governance, planning, etc. During this phase, the "service provider"
						reserves the right to make an amendment to the estimate for exceeding the time of
						planned creation, addition of features not identified during the proposal
						commercial, new needs expressed, ...
					</li>
					<li>
						<i> Development </i>: study and choice of the target solution, proposal and validation
						models and / or prototypes. Whether for a website or any other
						communication medium, a model of the graphic charter is presented to the
						"Client" for validation. The "service provider" grants him the possibility of
						request modifications to this model. The requested changes
						must be precise, concise, clear and definitive. The modified model
						will be presented to him a second time for validation, and a third time
						if need for some details. The "client" agrees to validate the models
						by signing a proof (proof) by email or in writing within 10
						open days. The validation of the proof confirms and definitively validates the
						graphic, technical and functional scope of the project. All news
						requests after validation of the proof may result in an amendment to the project.
					</li>
					<li>
						<i> Construction </i>: development and implementation of validated elements, settings,
						initialization of content, tests, etc.
					</li>
					<li>
						<i> Transition </i>: installation in production, organization of maintenance,
						User training, …
					</li>
				</ul>
				<p>
					The delivery of the project will be validated following a receipt made by the
					" service provider ". This recipe will follow a customer journey present in a
					recipe book produced by the “customer”, if provided to the “service provider”.
					Following delivery and during the entire delivery guarantee
					(by default, delivery + 30 days), the "service provider" will take care of,
					if necessary, the correction of anomalies noted by the "client".
					In order to speed up the diagnosis, the "client" will provide the "service provider" with
					for each anomaly observed, a descriptive explanation as well as the
					associated screenshots ...
				</p>
				<p>
					After the 30-day period, any request will be subject to an amendment except
					contrary contract between the "customer" and the "service provider" (maintenance, ...)
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 11 - Annual maintenance</h1>
				<p>
					By default, the "service provider" will suggest to the "client", for any implementation
					website or other web communication medium, annual maintenance which guarantees:
				</p>
				<ul>
					<li>
						corrective maintenance: repairing errors observed by the "customer"
						and defined as proven by the "service provider"
					</li>
					<li>
						progressive maintenance: regular implementation of available minor versions
						(security patches, fixes and new features, ...)
					</li>
					<li>
						user support, assistance, ...
					</li>
					<li>
						technical supervision and coordination of potential partners
					</li>
					<li>
						modification of content up to a maximum of 3 revisions per year
					</li>
					<li>
						an "analytical follow-up" option (evaluation, follow-up and recommendations): annual report on operation, quality of content, recommendations and proposal for development, ...
					</li>
				</ul>
				<p>
					Migration to a major version of the programming tool put in place
					or to another system could not be taken into account in this maintenance;
					this kind of operation generally requiring an overhaul of the initial developments,
					it will have to be the subject of a new order.
				</p>
				<p>
					By default, the service cannot guarantee total protection against piracy.
					IT, the "service provider" could not be held liable in the event of
					possible data theft or malicious actions on the site. The customer "
					undertakes to keep confidential the administration accounts that will have been
					provided and to be vigilant with regard to protection (firewall, antivirus, anti-spyware, etc.)
					computer equipment used.
				</p>
				<p>
					In addition, the "service provider" cannot be held responsible for any losses.
					data following a failure to back them up.
				</p>
				<p>
					By default, the annual maintenance price will be, at a minimum, equal to:
				</p>
				<ul>
					<li>
						15% of the amount of the realization
					</li>
					<li>
						20% of the amount of the realization if the "analytical follow-up" option is selected
					</li>
				</ul>
				<p>
					This percentage can be adjusted according to the scope requested by the “customer”.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 12 - Orders and prices</h1>
				<p>
					Sales of services are only perfect after establishing an estimate
					and written acceptance of the "customer" order. Acceptance of the quote
					signed will automatically act as an order and constitute irrevocable consent
					and final on the part of the "client".
				</p>
				<p>
					The services are provided at the rates in effect on the day of the
					placing the order, according to the estimate previously established by "the service provider"
					and accepted by the "client".
				</p>
				<p>
					The prices show the price excluding VAT, VAT and the price including VAT.
				</p>
				<p>
					An invoice is established by "the service provider" and given to the "customer" when
					of each provision of services.
				</p>
				<p>
					The conditions for determining the cost of services the price of which cannot be
					known a priori nor indicated with accuracy will be communicated to the "client"
					or will be the subject of a detailed estimate, at the request of the "customer".
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 13 - Payment conditions</h1>
				<p>
					A deposit corresponding to 30% of the total price of the services ordered is required
					when placing the order, except in the event of an agreement with "the service provider"
					and appearing on the estimate. The order will only be confirmed upon receipt of payment.
					of the deposit. In case of cancellation of the order by the "customer" after its acceptance,
					for any reason whatsoever except force majeure, the deposit paid when ordering
					will automatically be acquired by the “service provider” and will not give rise to any reimbursement.
				</p>
				<p>
					The balance is payable in cash, on the day of the provision of said services in
					the conditions defined in article 9 "Terms of provision of services".
					No discount will be applied by the "service provider" for cash payment or
					within a period shorter than that appearing in these T & Cs or on the issued invoice
					by the "provider".
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 14 - Penalties</h1>
				<p>
					In the event of late payment and payment of sums due by the "customer"
					beyond the deadline set above, and after the payment date appearing on the
					invoice sent to the latter, late penalties calculated at the daily rate
					3 times the legal interest rate of the amount including tax of the price of the services listed
					on said invoice, will automatically and automatically be acquired by the "service provider",
					without any formality or prior notice and will result in the
					immediate of all sums due to the "service provider" by the "client",
					without prejudice to any other action that the "service provider" would be entitled to bring,
					as such, against the “client”.
				</p>
				<p>
					Late payment interest = amount due (including VAT) x interest rate x (number of days late / 365) <br>
					<a href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F23211"> more info ... </a>
				</p>
				<p>
					In addition, any professional in a situation
					late payment is automatically liable for a lump sum compensation of 40 €
					for collection costs.
				</p>
				<p>
					In the event of non-compliance with the terms of payment appearing above, the "service provider"
					furthermore reserves the right to suspend or cancel the provision of the services of
					services ordered by the "client". He also reserves the right to suspend
					fulfillment of its obligations and reduce or even cancel any discounts
					granted to the latter.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 15 - Price and revision</h1>
				<p>
					The prices indicated in the quotation or the price proposal will be valid for a period of
					30 day period; beyond this date, any quotation must be revalued.
				</p>
				<p>
					The price of maintenance will be revised every year on the anniversary date of the contract.
					by applying the last variation of the Syntec index published and according to the following formula:
					P = P0 * S / S0
				</p>
				<p>
					with:
				</p>
				<ul>
					<li>
						P = new price after revision
					</li>
					<li>
						P0 = price on the date of signature of the contract
					</li>
					<li>
						S0 = value of the last Syntec index published on the date of signature of the contract
					</li>
					<li>
						S = value of the last Syntec index published on the revision date
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 16 - Duration and termination</h1>
				<p>
					This contract takes effect from the signing of the order. Maintenance, if contracted,
					takes effect upon delivery of the service. It covers a period of one year and is
					will then continue by tacit agreement unless terminated by one or other of the
					parties subject to a 3-month notice sent by registered letter
					with acknowledgment of receipt.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 17 - Limitation of responsability</h1>
				<p>
					The entire responsibility of the "service provider" relating to any breach, negligence or fault,
					noted during the performance of services, will be capped at the amount of fees
					paid for the services in question, in order to cover the claims of any
					nature (interest and costs included), regardless of the number of shares, foundations
					invoked, or parties to litigation.
				</p>
				<p>
					This stipulation will not apply to responsability for death or bodily injury,
					nor any other responsability that the law prohibits excluding or limiting.
				</p>
				<p>
					In addition, the responsibility of the "service provider" cannot be engaged in the following cases:
				</p>
				<ul>
					<li>
						following a failure or deficiency of a product or service whose
						supply or delivery is not the responsibility of it, nor of any subcontractors
					</li>
					<li>
						for facts and / or data that do not fall within the scope of the services
						and / or which are not an extension of it
					</li>
					<li>
						in the event of use of the results of the services, for an object or in a context
						different from that in which he intervened, of erroneous implementation of
						recommendations or failure to take into account the reservations of the "service provider"
					</li>
					<li>
						in the event of a malfunction due to the use of a tool (browser, software, etc.)
						not respecting the standards in force (W3C standards, etc.)
					</li>
				</ul>
				<p>
					The "service provider" is not liable for its insurers or for indirect damage, or for the lack of
					gain or loss of chance or expected benefits, nor of the consequences
					financial actions that may be brought by third parties against the "client".
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 18 - Force majeure</h1>
				<p>
					The responsibility of the "service provider" cannot be sought in the event of
					force majeure or fortuitous event.
				</p>
				<p>
					In this case, the execution of the contract will be suspended. If cases of force majeure
					have a duration of more than 1 month, this contract may be
					terminated by either party.
				</p>
				<p>
					Expressly, but not limited to, are considered a case of force
					major or fortuitous events, in addition to those usually retained by case law
					French courts and tribunals, namely any unforeseeable event and
					irresistible to parties (eg blocking telecommunications).
				</p>
				<p>
					It is understood that in these circumstances, the "service provider" undertakes to
					seek any solution allowing, under reasonable conditions to
					cost and operating constraints, to continue normal execution
					services covered by this contract.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 19 - Transferability / subcontracting</h1>
				<p>
					The parts having been chosen according to their personality, they
					expressly refrain from assigning this contract in whole or in part,
					for consideration or free, in any form whatsoever.
				</p>
				<p>
					If the service requires specific technical skills,
					the "service provider" will inform the "client" about the possibility of subcontracting it
					a part. The subcontractor will then intervene under the sole responsibility
					of the "service provider" and will undertake to keep confidential all
					information that he will be aware of during the services.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 20 - Applicable law and competent jurisdiction</h1>
				<p>
					Both the conditions of use of the services and the methods of acquiring
					services provided by the "service provider" are governed by French law which
					regardless of the place of use or acquisition. In the event of a possible dispute
					on the interpretation or the execution of these conditions and after
					the failure of any attempt to find an amicable solution, the competence
					express is attributed to the French courts, and in particular to the Tribunal de
					Coutances trade.
				</p>
			</article>
		</section>
	{:else}
		<h1 class="article__h1" class:article__minitel__h1={$minitel}>CONDITIONS GÉNÉRALES DE VENTE</h1>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
				class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>PRESTATIONS DE SERVICE INFORMATIQUE</h1>
				<p class="article__p">
					Les présentes sont conclues entre :
				</p>
				<p class="article__p">
					KÖRTEFA - Yvan Poirier - Auto Entrepreneur, élisant domicile au 
					3 lotissement Redier 50590 Montmartin sur mer, FRANCE, 
					identifié sous le numéro de SIREN 801 185 448, 
					représentée par Yvan Poirier.<br>
					Ci-après nommée le « prestataire »
				</p>
				<p class="article__p">
					Et toute personne physique ou morale, particulier ou professionnel, 
					de droit privé ou de droit public souhaitant s'engager dans une ou plusieurs 
					des prestations fournies par le « prestataire ».<br>
					Ci-après nommée le « client »
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 1 - Champ d'application</h1>
				<p>
					Les présentes conditions générales de vente (ci-après « CGV ») s'appliquent à toutes les prestations 
					de services informatiques conclues par le « prestataire » auprès de son « client », quelles 
					que soient les clauses pouvant figurer sur les documents du « client », notamment ses conditions 
					générales d'achat.
				</p>
				<p>
					En signant un devis du « prestataire », le « client » reconnaît avoir eu une 
					parfaite connaissance des CGV.
				</p>
				<p>
					Chacune des clauses du contrat se suffit à elle-même, l'invalidation de l'une 
					n'ayant aucun effet sur les autres.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 2 - Obligations du « prestataire »</h1>
				<p>
					Le « prestataire » est responsable de la bonne gestion des dossiers confiés. 
					Les engagements du « prestataire » constituent une obligation de moyens, et 
					non de résultat, aux termes de laquelle les prestations seront exécutées dans 
					le strict respect des règles professionnelles en usage ainsi, le cas échéant, 
					que conformément aux conditions du contrat.
				</p>
				<p>
					Le « prestataire » reconnaît être tenu à une obligation de conseil et de mise 
					en garde, notamment d'information et de recommandation au « client » limitée 
					au périmètre des prestations. Dans ce cadre, le « prestataire » doit fournir 
					au « client » l'ensemble des conseils, mises en garde et recommandations 
					nécessaires, notamment en termes de qualité de service et de mise à l'état de 
					l'art. Le « prestataire » s'engage à conseiller le « client » dans le cas où 
					ce dernier émettrait des demandes complémentaires ou nouvelles, en cours 
					d'exécution des présentes. Le « prestataire » s'engage également à informer 
					le « client » dès que le « prestataire » aura eu connaissance de toute nouveauté 
					technologique ou de disponibilité de tous nouveaux produits ou services permettant 
					d'améliorer notablement la prestation, et qui surviendrait en cours d'exécution des présentes.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 3 - Obligations du « client »</h1>
				<p>
					Afin de faciliter la bonne exécution des prestations, le « client » s’engage :
				</p>
				<ul>
					<li>
						à fournir au « prestataire » des informations et documents complets, 
						exacts et dans les délais nécessaires sans qu’il soit tenu d’en vérifier 
						le caractère complet ou l’exactitude
					</li>
					<li>
						à prendre les décisions dans les délais et d’obtenir les approbations hiérarchiques nécessaires
					</li>
					<li>
						à désigner un correspondant investi d’un pouvoir de décision
					</li>
					<li>
						à faire en sorte que les interlocuteurs clé et le correspondant soient disponibles 
						tout au long de l’exécution des prestations
					</li>
					<li>
						à avertir directement le « prestataire » de toute difficulté éventuelle relative 
						à l’exécution des prestations
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 4 - Information et confidentialité</h1>
				<p>
					Le « prestataire » est assujetti à une obligation légale de secret professionnel.
				</p>
				<p>
					Chacune des parties s’engage, en son nom et celui de leurs personnels, à ne pas 
					divulguer les informations confidentielles reçues de l’autre partie. Les informations 
					confidentielles s’entendent des informations de toute nature, visuelles ou orales, 
					sur quelque support que ce soit, relatives à la structure, l’organisation, 
					les affaires, les politiques internes diverses, les projets et le personnel 
					de chacune des parties. Sous réserve des exceptions visées ci-après, la présente 
					obligation de confidentialité produira ses effets pendant une durée de 1 an suivant 
					le terme des prestations. Ont également un caractère confidentiel, le contenu des 
					prestations ainsi que les rapports, courriers, informations, notes, devis, 
					fournis par le « prestataire » au cours de l’exécution des prestations. 
					Ces documents sont communiqués au « client » pour un usage strictement interne et 
					à la condition de ne pas les divulguer à des tiers ni de les annexer à un document 
					qu’il serait amené à produire. Si le « client » souhaite que tout ou partie de ces 
					documents soient divulgués à/ou utilisés par un tiers, il doit en demander 
					l’autorisation préalable par écrit au « prestataire ». Des modalités applicables 
					à cette divulgation seront alors fixées.
				</p>
				<p>
					Les obligations et restrictions énoncées ci-dessus ne s’appliquent pas aux informations confidentielles :
				</p>
				<ul>
					<li>
						qui appartiennent au domaine public, ou ont été 
						acquises librement avant le début de la prestation
					</li>
					<li>
						qui sont ou deviennent connues autrement qu’à la suite d’une violation du présent article
					</li>
					<li>
						qui sont ou deviennent connues grâce à d’autres sources non tenues à une restriction de divulgation
					</li>
					<li>
						qui doivent être communiquées en vertu d’une obligation légale ou professionnelle ou à 
						la demande de toute autorité judiciaire ou réglementaire habilitée à exiger la 
						divulgation des informations confidentielles
					</li>
				</ul>
				<p>
					Sous réserve de ses obligations en matière de confidentialité, le « prestataire » se 
					réserve le droit d’exécuter des prestations pour des entreprises concurrentes de 
					celle du « client ».
				</p>
				<p>
					Le « client » reconnaît et accepte :
				</p>
				<ul>
					<li>
						que les parties pourront, sauf demande expresse contraire de l’autre partie, correspondre ou transférer 
						des documents par courrier électronique circulant sur le réseau internet
					</li>
					<li>
						qu’aucune des parties n’exerce de maîtrise sur la capacité, la fiabilité, 
						l’accès ou la sécurité de ces courriers électroniques
					</li>
					<li>
						que le « prestataire » ne saura être tenu pour responsable de toute perte, dommage, 
						frais ou préjudice occasionnés par la perte, le retard, l’interception, 
						le détournement ou l’altération de tout courrier électronique causé par un fait quelconque
					</li>
				</ul>
				<p>
					Le « prestataire » ne commercialise, ni ne loue les informations recueillies à des tiers.
				</p>
				<p>
					De façon générale, les parties s’engagent à respecter la réglementation applicable à la 
					protection des données personnelles et notamment les dispositions de la loi 78-17 du 6 
					janvier 1978 relative à l’informatique, aux fichiers et aux libertés. En application de 
					l'article 27 de cette loi, le « client » dispose d'un droit d'accès et de rectification 
					sur les données concernant le « client ». Il suffit pour ce faire d'adresser un e-mail 
					au « prestataire » à l'adresse contact@kortefa.net ou écrire au « prestataire », 
					3 lotissement Redier 50590 Montmartin sur mer.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 5 - Propriété intellectuelle</h1>
				<p>
					Au cas où l’une des recommandations du « prestataire » ou l’utilisation d’éléments 
					livrés à la suite de l’une de ses préconisations impliquerait l’utilisation de biens 
					faisant l’objet de droits de propriété intellectuelle appartenant à des tiers, 
					le « prestataire » informera le « client » de l’existence de ces droits et des 
					conséquences de leur utilisation. Il appartiendra alors au « client » et sous sa 
					seule responsabilité de prendre toute mesure permettant l’utilisation de tels droits, 
					notamment en négociant pour son propre compte les droits d’utilisation dans des 
					conditions telles que le « prestataire » soit en mesure de s’en prévaloir pour 
					les besoins des prestations.
				</p>
				<p>
					Le « prestataire » reste propriétaire de tous les droits de propriété intellectuelle 
					et industrielle sur les études, dessins, modèles, prototypes, … réalisés en vue de 
					la fourniture des services par le « prestataire » au « client ». Le « client » 
					s'interdit donc toute reproduction ou exploitation desdites œuvres sans l'autorisation 
					expresse, écrite et préalable du « prestataire » qui peut la conditionner à une 
					contrepartie financière.
				</p>
				<p>
					Le « client » s’engage à fournir au « prestataire » des photos dont il a les droits à l'image.
				</p>
				<p>
					Le « prestataire » ne sera en aucun cas responsable ni des photos fournies par le « client », 
					ni des textes rédigés par celui-ci, autant sur les sites internet que sur tout autre 
					support de communication réalisé par le « prestataire » pour son « client ».
				</p>
				<p>
					Le « prestataire » se réserve toutefois le droit de ne pas publier ou ne pas 
					imprimer des photos ou des textes jugés douteux ou non conformes à l’éthique 
					et à la déontologie.
				</p>
				<p>
					Le « prestataire » n’est pas chargé de la rédaction des textes du « client », 
					ni de la correction orthographique ou de syntaxe, sauf mention contraire dans le devis.
				</p>
				<p>
					Le « prestataire » pourra utiliser le logo du « client » afin de l'insérer dans 
					ses références sur ses différents supports de communication. Le « client » autorise 
					également le « prestataire » à illustrer, décrire les prestations réalisées et 
					faire pointer une page de son site internet sur l'adresse activée du nom de domaine 
					du « client », et ce, à titre d'exemple de réalisation.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 6 - Propriété des développements</h1>
				<p>
					Par défaut les programmes et autres développements (fichiers, données, ...) que 
					le « prestataire » transmettra au « client » pour la validation du contrat, 
					restent la propriété exclusive du « client ».
				</p>
				<p>
					Cela est valable pour l’ensemble des développements réalisés sur une base libre (open source).
					Le « client » pourra ainsi faire intervenir des prestataires autres que le « prestataire » 
					pour la maintenance ou le développement d’autres éléments, sous réserve du respect par 
					ce dernier des présentes conditions de licence.
				</p>
				<p>
					Toutefois, cette disposition ne peut s'appliquer tant que le « client » est lié par un 
					contrat de maintenance, accepté sur devis, tel que décrit à l'article 11 
					« Maintenance annuelle ». En effet, le « prestataire » ne saurait garantir 
					une qualité de service sur des développements dont il n'a pas connaissance.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 7 - Noms de domaine et hébergement</h1>
				<h2>Avec maintenance</h2>
				<p>
					Le « prestataire » conseille le « client » dans le choix d'un ou plusieurs noms 
					de domaine et hébergement associé, et ce en fonction des besoins exprimés par 
					le « client ». Si le « client » dispose déjà de tels environnements, il doit 
					fournir au « prestataire » toutes les informations nécessaires pour les administrer. 
					Le « prestataire » n'est propriétaire, ni du ou des noms de domaine, ni de 
					l'hébergement, le propriétaire est le « client ». Le « client » autorise 
					le « prestataire » à s'enregistrer comme contact technique afin d'administrer 
					les environnements techniques chez l'hébergeur. Le « client » sera enregistré 
					comme contact administratif et contact de facturation. A ce titre, charge au 
					« client » de renouveler ses services et de s'acquitter des factures auprès de l'hébergeur.
				</p>
				<p>
					Le « prestataire » veillera aux échéances et préviendra le « client » des actions à réaliser.
				</p>
				<p>
					Le fait de ne pas renouveler les services auprès de l'hébergeur ne pourrait 
					être une raison recevable de résiliation du présent contrat.
				</p>
				<p>
					De plus, le « prestataire » ne pourrait voir sa responsabilité engagée en cas 
					d'indisponibilité du service d'hébergement ou de tout autre manque de qualité 
					de service imputable à l'hébergeur et fournisseur de nom de domaine. Le « client » 
					se référera aux conditions générales de vente de l'hébergeur, et plus particulièrement aux :
				</p>
				<ul>
					<li>
						conditions particulières d'hébergement web
					</li>
					<li>
						conditions particulières noms de domaines
					</li>
					<li>
						conditions générales de service
					</li>
					<li>
						...
					</li>
				</ul>
				<h2>Sans maintenance</h2>
				<p>
					Le « client » sera responsable de toute relation avec l'hébergeur (gestion, coût, infrastructure). Le « prestataire » n'interviendra pas dans cette relation.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 8 - Réseaux sociaux et autres plateformes de communication web sur internet</h1>
				<p>
					Selon les besoins exprimés par le « client » et validés lors de la commande, 
					le « prestataire » pourra conseiller et mettre en place  un 
					dispositif de communication web auprès des grands acteurs du marché 
					(Facebook, Google, Twitter, …). Le « client » sera ensuite en charge 
					d'administrer ces différents comptes, pages, flux et contenus. Le « client » 
					est le propriétaire de ces différents comptes, pages, flux et contenus et 
					est seul responsable des textes, images, vidéos, … diffusés ainsi que des propos tenus.
					Le « prestataire » ne pourrait voir sa responsabilité engagée en cas de 
					manquement aux droits à l'image, droits d'auteur, non conformité à l'éthique 
					et à la déontologie, ainsi qu'en cas d'indisponibilité des plateformes ou 
					tout autre manque de qualité de service imputable à ces fournisseurs externes.
				</p>
				<p>
					Le « client » se référera aux diverses conditions de ces fournisseurs, 
					et plus particulièrement aux :
				</p>
				<ul>
					<li>
						conditions applicables aux pages Facebook
					</li>
					<li>
						conditions et règlements de Facebook (dites « policies »)
					</li>
					<li>
						conditions d’utilisation de Google
					</li>
					<li>
						règles de confidentialité de Google
					</li>
					<li>
						conditions d’utilisation de Twitter
					</li>
					<li>
						...
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 9 - Modalités de fourniture des prestations</h1>
				<p>
					Conformément aux principes de la liberté contractuelle, toutes les modalités de 
					fourniture des services demandés sont à peu près envisageables. Il est à noter 
					qu’à défaut de délai contractuel de fourniture des prestations, le « prestataire » 
					doit réaliser celles-ci dans un délai raisonnable et informer le « client » de 
					tout retard. Une date de mise en ligne pour un site internet ou de livraison 
					pour tout autre support de communication, est fixée au plus tard en phase 
					d'élaboration telle que décrite à l'article 10 « Conditions d'exécution ». 
					Le « prestataire » s’engage à respecter ce délai, si, et seulement si, tous 
					les éléments devant être fournis par le « client » (textes numérisés, images, 
					validation de charte graphique, renseignements et tout élément émanant 
					du « client ») sont fournis dans les temps et les conditions définies par 
					le « prestataire ». Ce délai ne constitue pas un délai de rigueur et le 
					« prestataire » ne pourra voir sa responsabilité engagée à l’égard du « client » 
					en cas de retard des prestataires fournisseurs. La responsabilité du « prestataire » 
					ne pourra en aucun cas être engagée en cas de retard ou de suspension de la 
					fourniture de la prestation imputable au « client », ou en cas de force majeure.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 10 - Conditions d'exécution</h1>
				<p>
					La proposition commerciale reprend l'ensemble des points sur lesquels le « prestataire » 
					interviendra. Une fois signée par le « client », le « prestataire » lancera 
					la prestation avec le « client », dont le déroulement s'organise généralement en 4 phases :
				</p>
				<ul>
					<li>
						<i>Avant-projet</i> : analyse de l'existant, écoute, conseil, sensibilisation, validation 
						des objectifs et du périmètre, spécifications détaillées et précisions du cahier 
						des charges, orientations graphiques, définition des types de contenu et 
						fonctionnalités, gouvernance, planning, … Lors de cette phase, le « prestataire » 
						se réserve le droit de faire un avenant au devis pour dépassement du temps de 
						création prévu, ajout de fonctionnalités non identifiées lors de la proposition 
						commerciale, nouveaux besoins exprimés,...
					</li>
					<li>
						<i>Élaboration</i> : étude et choix de la solution cible, proposition et validation 
						des maquettes et/ou prototypes. Que ce soit pour un site internet ou tout autre 
						support de communication, une maquette de la charte graphique est présentée au 
						« client » pour validation. Le « prestataire » lui accorde la possibilité de 
						demander des modifications de cette maquette. Les modifications demandées 
						doivent être précises, concises, claires et définitives. La maquette modifiée 
						lui sera présentée une deuxième fois pour validation, et une troisième fois 
						si besoin pour certains détails. Le « client » s’engage à valider les maquettes 
						en signant un BAT (bon à tirer) par mail ou par écrit dans un délai de 10 
						jours ouvrés. La validation du BAT confirme et valide définitivement le 
						périmètre graphique, technique et fonctionnel du projet. Toutes nouvelles 
						demandes après validation du BAT pourra avoir pour conséquence un avenant au projet.
					</li>
					<li>
						<i>Construction</i> : développement et mise en place des éléments validés, paramétrages, 
						initialisation des contenus, tests, …
					</li>
					<li>
						<i>Transition</i> : installation en production, organisation de la maintenance, 
						formation des utilisateurs, …
					</li>
				</ul>
				<p>
					La livraison du projet sera validée suite à une recette réalisée par le 
					« prestataire ». Cette recette suivra un parcours client présent dans un 
					cahier de recette réalisé par le « client », si fourni au « prestataire ». 
					Suite à la livraison et durant l'ensemble de la garantie de la livraison 
					(par défaut, livraison + 30 jours), le « prestataire » prendra en charge, 
					s'il y a lieu, la correction des anomalies constatées par le « client ». 
					Afin d’accélérer le diagnostic, le « client » fournira au « prestataire », 
					pour chaque anomalie constatée, une explication descriptive ainsi que les 
					copies d'écrans associées...
				</p>
				<p>
					Passé le délai des 30 jours, toute demande fera l'objet d'un avenant sauf 
					contrat contraire entre le « client » et le « prestataire » (maintenance, ...)
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 11 - Maintenance annuelle</h1>
				<p>
					Par défaut, le « prestataire » proposera au « client », pour toute mise en place 
					de site internet ou autre support de communication web, une maintenance annuelle qui garantit :
				</p>
				<ul>
					<li>
						la maintenance corrective : réparer les erreurs constatées par le « client » 
						et définies avérées par le « prestataire »
					</li>
					<li>
						la maintenance évolutive : mise en place régulière des versions mineures disponibles 
						(patchs de sécurité, correctifs et nouvelles fonctionnalités, …)
					</li>
					<li>
						le support à l’utilisation, l'assistance, …
					</li>
					<li>
						la supervision technique et coordination des éventuels partenaires
					</li>
					<li>
						modification de contenu à hauteur de maximum 3 révisions par an
					</li>
					<li>
						une option "suivi analytique" (évaluation, suivi et recommandations) : bilan annuel quant au fonctionnement, 
						qualité du contenu, préconisations et proposition d'évolution, ...
					</li>
				</ul>
				<p>
					La migration vers une version majeure de l'outil de programmation mis en place 
					ou vers un autre système ne pourrait être prise en compte dans cette maintenance ; 
					ce genre d'opération demandant généralement une refonte des développements initiaux, 
					elle devra faire l'objet d’une nouvelle commande.
				</p>
				<p>
					Par défaut, la prestation ne pouvant garantir une totale protection contre le piratage 
					informatique, le « prestataire » ne pourrait voir sa responsabilité engagée en cas 
					d'éventuels vols de données ou actions malveillantes sur le site. Le « client » 
					s'engage à garder confidentiels les comptes d'administration qui lui auront été 
					fournis et à être vigilant quant à la protection (pare-feu, antivirus, anti-espion, …) 
					du matériel informatique utilisé.
				</p>
				<p>
					De plus, le « prestataire » ne pourra être tenu responsable d'éventuelles pertes 
					de données suite à un défaut de sauvegarde de ces dernières.
				</p>
				<p>
					Par défaut, le prix annuel de la maintenance sera, à minima, égal à :
				</p>
				<ul>
					<li>
						15% du montant de la prestation
					</li>
					<li>
						20% du montant de la prestation si l'option "suivi analytique" est retenue
					</li>
				</ul>
				<p>
					Ce pourcentage pouvant être ajusté en fonction du périmètre demandé par le « client ».
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 12 - Commandes et tarifs</h1>
				<p>
					Les ventes de prestations ne sont parfaites qu’après établissement d’un devis 
					et acceptation par écrit de la commande du « client ». L’acceptation du devis 
					signé fera automatiquement office de commande et vaudra consentement irrévocable 
					et définitif de la part du « client ».
				</p>
				<p>
					Les prestations de services sont fournies aux tarifs en vigueur au jour de la 
					passation de la commande, selon le devis préalablement établi par « le prestataire » 
					et accepté par le « client ».
				</p>
				<p>
					Les tarifs mettent en évidence le prix HT, la TVA et le prix TTC.
				</p>
				<p>
					Une facture est établie par « le prestataire » et remise au « client » lors 
					de chaque fourniture de services.
				</p>
				<p>
					Les conditions de détermination du coût des services dont le prix ne peut être 
					connu a priori ni indiqué avec exactitude seront communiquées au « client » 
					ou feront l’objet d’un devis détaillé, à la demande du « client ».
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 13 - Conditions de règlement</h1>
				<p>
					Un acompte correspondant à 30 % du prix total des prestations commandées est exigé 
					lors de la passation de la commande, sauf en cas d’accord passé avec « le prestataire » 
					et figurant sur le devis. La commande ne sera confirmée qu'à réception du versement 
					de l'acompte. En cas d'annulation de la commande par le « client » après son acceptation, 
					pour quelque raison que ce soit hormis la force majeure, l'acompte versé à la commande 
					sera de plein droit acquis au « prestataire » et ne pourra donner lieu à un quelconque remboursement.
				</p>
				<p>
					Le solde est payable au comptant, au jour de la fourniture desdites prestations dans 
					les conditions définies à l'article 9 «  Modalités de fourniture des prestations ».
					Aucun escompte ne sera pratiqué par le « prestataire » pour paiement comptant ou 
					dans un délai inférieur à celui figurant aux présentes CGV ou sur la facture émise 
					par le « prestataire ».
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 14 - Pénalités</h1>
				<p>
					En cas de retard de paiement et de versement des sommes dues par le « client » 
					au-delà du délai ci-dessus fixé, et après la date de paiement figurant sur la 
					facture adressée à celui-ci, des pénalités de retard calculées au taux journalier 
					de 3 fois le taux d'intérêt légal du montant TTC du prix des prestations figurant 
					sur ladite facture, seront automatiquement et de plein droit acquises au « prestataire », 
					sans formalité aucune ni mise en demeure préalable et entraînera l'exigibilité 
					immédiate de la totalité des sommes dues au « prestataire » par le « client », 
					sans préjudice de toute autre action que le « prestataire » serait en droit d'intenter, 
					à ce titre, à l'encontre du « client ».
				</p>
				<p>
					Intérêts de retard = montant dû (ttc) x taux d'intérêt x (nbre de jours de retard / 365)<br>
					<a href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F23211">plus d'infos ...</a>
				</p>
				<p>
					De plus, tout professionnel en situation de 
					retard de paiement est de plein droit débiteur d'une indemnité forfaitaire de 40€ 
					pour frais de recouvrement.
				</p>
				<p>
					En cas de non-respect des conditions de paiement figurant ci-dessus, le « prestataire » 
					se réserve en outre le droit de suspendre ou d'annuler la fourniture des prestations de 
					services commandées par le « client ». Il se réserve également la faculté de suspendre 
					l'exécution de ses obligations et de diminuer voire d'annuler les éventuelles remises 
					accordées à ce dernier.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 15 - Prix et révision</h1>
				<p>
					Les prix indiqués dans le devis ou la proposition de prix seront valables pendant une 
					période de 30 jours ; au delà de cette date, toute cotation devra être revalorisée.
				</p>
				<p>
					Le prix de la maintenance sera révisé tous les ans à la date d'anniversaire du contrat 
					en appliquant la dernière variation de l'indice Syntec publiée et selon la formule suivante : 
					P = P0 * S / S0
				</p>
				<p>
					avec :
				</p>
				<ul>
					<li>
						P = nouveau prix après révision
					</li>
					<li>
						P0 = prix à la date de signature du contrat
					</li>
					<li>
						S0 = valeur du dernier indice Syntec publié à la date de signature du contrat
					</li>
					<li>
						S = valeur du dernier indice Syntec publié à la date de révision
					</li>
				</ul>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 16 - Durée et résiliation</h1>
				<p>
					Le présent contrat prend effet dès la signature de la commande. La maintenance, si contractée, 
					prend effet dès la livraison de la prestation. Elle couvre une période d'un an et se 
					poursuivra ensuite par tacite reconduction sauf dénonciation par l'une ou l'autre des 
					parties moyennant le respect d'un préavis de 3 mois adressé par lettre recommandée 
					avec accusé de réception.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 17 - Limitation de responsabilité</h1>
				<p>
					L’entière responsabilité du « prestataire » relative à tout manquement, négligence ou faute, 
					relevé à l’occasion de l’exécution des prestations, sera plafonnée au montant des honoraires 
					versés au titre des prestations mis en cause, afin de couvrir les réclamations de toute 
					nature (intérêts et frais inclus) et ce, quel que soit le nombre d’actions, de fondements
					 invoqués, ou de parties aux litiges.
				</p>
				<p>
					Cette stipulation ne s’appliquera pas à une responsabilité pour décès ou blessure corporelle,
					 ni à toute autre responsabilité que la loi interdit d’exclure ou de limiter.
				</p>
				<p>
					Par ailleurs, la responsabilité du « prestataire » ne pourra être engagée dans les cas suivants :
				</p>
				<ul>
					<li>
						suite à un manquement ou à une carence d’un produit ou d’un service dont la 
						fourniture ou la livraison ne lui incombe pas, ni à ses sous-traitants éventuels
					</li>
					<li>
						pour les faits et/ou données qui n’entrent pas dans le périmètre des prestations 
						et/ou qui n’en sont pas le prolongement
					</li>
					<li>
						en cas d’utilisation des résultats des prestations, pour un objet ou dans un contexte 
						différent de celui dans lequel il est intervenu, de mise en œuvre erronée des 
						recommandations ou d’absence de prise en compte des réserves du « prestataire »
					</li>
					<li>
						en cas de dysfonctionnement dû à l'utilisation d'un outil (navigateur, logiciel ...) 
						ne respectant pas les standards en vigueur (normes W3C ...)
					</li>
				</ul>
				<p>
					Le « prestataire » ne répond ni ses assureurs ni des dommages indirects, ni du manque 
					à gagner ou de la perte de chance ou de bénéfices escomptés, ni des conséquences 
					financières des actions éventuellement intentées par des tiers à l’encontre du « client ».
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 18 - Force majeure</h1>
				<p>
					La responsabilité du « prestataire » ne saurait être recherchée en cas de 
					force majeure ou cas fortuit.
				</p>
				<p>
					Dans ce cas, l'exécution du contrat sera suspendue. Si les cas de force majeure 
					ont une durée d'existence supérieure à 1 mois, le présent contrat pourra être 
					résilié par l'une ou l'autre des parties.
				</p>
				<p>
					De façon expresse, mais non limitative, sont considérés comme cas de force 
					majeure ou cas fortuits, outre ceux habituellement retenus par la jurisprudence 
					des cours et tribunaux français, à savoir tout événement imprévisible et 
					irrésistible aux parties (par exemple, blocage des télécommunications).
				</p>
				<p>
					Il est entendu que dans ces circonstances, le « prestataire » s'engage à 
					rechercher toute solution permettant, dans des conditions raisonnables de 
					coût et de contraintes d'exploitation, de poursuivre l'exécution normale 
					des prestations objet du présent contrat.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__right={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 19 - Cessibilité / sous-traitance</h1>
				<p>
					Les parties ayant été choisies en fonction de leur personnalité, elles 
					s'interdisent expressément de céder le présent contrat en tout ou partie, 
					à titre onéreux ou gratuit, sous quelque forme que ce soit.
				</p>
				<p>
					Si la prestation requiert des compétences techniques particulières, 
					le « prestataire » informera le « client » sur la possibilité d’en sous-traiter
					une partie. Le sous-traitant interviendra alors sous la seule responsabilité 
					du « prestataire » et s’engagera à conserver confidentielles toutes les 
					informations dont il aura connaissance à l’occasion des prestations.
				</p>
			</article>
		</section>
		<section class="section" class:section__deglingos={$deglingos} class:section__deglingos__left={$deglingos}
		class:section__minitel={$minitel}>
			<article
				class="article"
				class:article__deglingos={$deglingos}
				class:article__minitel={$minitel}
			>
				<h1 class:article__minitel__h1={$minitel}>Article 20 - Droit applicable et juridiction compétente</h1>
				<p>
					Tant les conditions d'utilisation des services que les modalités d'acquisition des 
					prestations du « prestataire » sont régies par la législation française quel 
					que soit le lieu d'utilisation ou d'acquisition. En cas de contestation éventuelle 
					sur l'interprétation ou sur l'exécution des présentes conditions et après 
					l'échec de toute tentative de recherche d'une solution amiable, la compétence 
					expresse est attribuée aux tribunaux français, et notamment au Tribunal de 
					Commerce de Coutances.
				</p>
			</article>
		</section>
	{/if}
</div>